var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trendChart-parent"},[_c('TrendChart',{key:_vm.test,attrs:{"datasets":_vm.data,"grid":{
        verticalLines: true,
        horizontalLines: true,
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }